//note!!! underscored labels e.g. __ack_tcs_required are deprecated and replaced by company's config json after ApiService.getAccount:
// e.g. labels['ack_tcs_required'] = application.account.payload_parsed['labels']['ack_tcs_required']
export const labels = {
  ua: {
    powered_by_label: 'Створено командою',
    team: 'Команда',
    mobile_exit_default: '👈 Повернутись в чат-бот',
    mobile_exit_on_error: '❌ Повернутись в чат-бот',
    mobile_exit_on_success: '✅ Повернутись в чат-бот',
    close: 'Закрити',
    delete: 'Видалити',
    cancel: 'Відміна',
    cancel2: 'Скасувати',
    save: 'Зберегти',
    confirm: 'Підтвердити',
    search: 'Пошук',
    copy: 'Скопіювати',
    canceled: 'Скасовано',
    new_search: 'Новий пошук',
    date_and_time: 'Дата і Час',
    duration: 'Тривалість',
    comment: 'Коментар',
    no_records_found: 'Записи відсутні.',
    coming_soon: 'Цей функціонал перебуває в активній розробці! Скоро буде ;)',
    booking_conflict: 'Вибачте, на вибраний час бронювання вже не доступне... Спробуйте вибрати інший час, але цього разу робіть бронювання трішки швидше ;)',
    pick_new_service: 'Новий сервіс',
    pick_new_proposal: 'Нова пропозиція',
    user_services_title: 'Сервіси клієнта',
    user_proposals_title: 'Пропозиції клієнту',
    'Pick calendar': 'Виберіть календар',
    pick_service_title: 'Виберіть новий сервіс',
    pick_proposal_title: 'Виберіть нову пропозицію',
    save_picked_service: 'Додати сервіс',
    save_picked_proposal: 'Додати пропозицію',
    user_services: 'Сервіси клієнта',
    user_proposals: 'Акції та Пропозиції',
    add_new_service: 'Додати новий сервіс',
    add_new_proposal: 'Додати нову пропозицію',
    proposal_custom_price_error: 'Ціна пропозиції вказана невірно!',
    'Prepaid bookings': 'Платні бронювання',
    'Forbid guest booking': 'Заборона гостьових бронювань',
    'Discount prices': 'Акційні ціни',
    'Profile info': 'Профіль користувача',
    'Is trainer profile': 'Включити як спеціаліста',
    'Published trainer': 'Ввімкнено в чат-боті',
    'Trainer settings': 'Налаштування спеціаліста',
    'Trainer sort order': 'Номер у списку',
    'Inventory / Equipment restriction': 'Обмеження по оренді обладнання',
    'Enable filter': 'Включити фільтр',
    save_trainer_settings: 'Зберегти налаштування',

    connect_label: 'Club connect', //typically overwritten by application.account.payload_parsed['connect_label']
    //my_club_connect: 'Мій SquashFit Connect',
    my: 'Мій',
    //top_label_public: 'SquashFit Connect',
    top_label_events: 'Події та Акції',
    top_label_cups: 'Турніри',
    __players_groups: 'Групи в клубі',
    top_label_ranks: 'Рейтинги Гравців',
    group_view: 'Перегляд Групи',
    my_calendar: 'Мій Календар',
    profile_edit: 'Реєстраційні Дані',
    club_trainers: 'Тренери Squash Center',
    book_trainer: 'Бронювання Тренування',
    view_trainer: 'Графік Тренера',
    my_schedule: 'Мій графік роботи',
    all_trainers: 'Графік усіх тренерів',
    squash_trainer_type: 'Тренер зі Сквошу',
    pool_trainer_type: 'Тренер з Більярду',
    driver_trainer_type: 'Інструктор',
    massage_trainer_type: 'Масажист',
    gym_trainer_type: 'Персональний тренер',

    game_status_proposal: 'Давай зіграємо!',
    game_status_pending: 'Запланована гра',
    game_status_score_confirmation: 'Запис рахунку',
    game_status_canceled: 'Відміна гри',
    game_status_confirmed: 'Зіграно гру!',
    add_game_result: 'Зафіксувати результат гри',

    contact: 'Контакт',
    account: 'Акаунт',
    event_view: 'Перегляд події',
    event_group: 'Подія/Група',
    members: 'Учасників',
    more: 'Детальніше...',
    pick: 'Вибрати',
    game_result: 'Результат гри',
    player_details: 'Деталі гравця',
    play_conf_not_set: 'N/A',
    generate_subscription_event: 'Згенерувати підписку...',
    generate_smart_subscription_event: 'Нова подія з підписками',
    'Subscribe!': 'Взяти участь!',
    cups_stopped: 'На даний момент турніри призупинені!',
    join_class: 'Вступити в групу!',
    wait_class_join_confirmation: 'Очікування підтердження...',
    leave_class: 'Вийти з групи',
    edit_class: 'Редагувати групу',
    toggle_activity_view: 'Активність групи',
    toggle_users_view: 'Учасники групи',
    edit: 'Редагувати',
    'Play game!': 'Зіграти гру!',
    'Plan game...': 'Запланувати гру.',
    training_proposal_booking: 'Забронювати тренування.',
    training_with_client: 'Тренування з клієнтом.',
    __call_to_game: 'Нова гра!',
    __call_to_game_trainer: 'Нове тренування/гра',
    new_calendar_event: 'Новий запис в графіку',
    edit_calendar_event: 'Редагування графіку',
    pick_event_type: 'Оберіть тип',
    event_start_time: 'Час початку',
    event_end_time: 'Час завершення',
    planned_training: 'Заплановане тренування',
    new_booking_event: 'Запис клієнта',
    new_training_event: 'Запис до спеціаліста',
    toggle_trainer_booking: 'Запис до спеціаліста',
    trainer_description: 'Опис тренера',
    pick_a_user: 'Вибрати клієнта',
    pick_package: 'Виберіть сервіс',
    pick_training_package: 'Виберіть сервіс і ',
    apply_service_checks: 'Врахувати сервіси із баланса клієнта',
    pick_court: 'Виберіть обладнання',
    available: 'На роботі',
    absent: 'Не доступний(-на)',
    hours: 'Години',
    duplicate_changes: 'Змінити всі записи такої групи',
    schedule_updated: 'Графік оновлено!',
    updated: 'Оновлено!',
    book_court: 'Забронювати корт...',
    my_bookings: 'Мої бронювання',
    user_bookings: 'Бронювання користувача',
    my_activity: 'Моя Активність',
    user_activity: 'Активність Користувача',
    my_profile: 'Мій Акаунт',
    user_profile: 'Перегляд Гравця',
    trainer_profile: 'Перегляд Тренера',
    invite_friends: 'Запросити друзів',
    share_group_menu: 'Поширити посилання',
    exit_group: 'Вийти з групи',
    record_game_score: 'Зафіксувати результат гри.',
    training_proposal_title: 'Нове тренування',
    game_proposal_title: 'Нова гра',
    game_confirmation_title: 'Зафіксувати гру',
    new_training_description: '🎓 Скористайтесь цією опцією, щоб запланувати тренування з "<b>{0}</b>". Ви перейдете у чат-бот, де зможете вибрати час і здійснити оплату або списати тренування з абонементу.<br />Тренер отримає повідомлення про тренування і бронювання в своєму графіку.',
    new_game_confirm_score_description: '🎾 Щойно зіграли гру з "<b>{0}</b>"? Перейдіть у чат-бот кнопкою нижче, щоб зафіксувати результат гри.<br />Ваш візаві отримає повідомлення у чат-боті для підтвердження результату.',
    new_game_plan_game_description: '📆 Скористайтесь цією опцією, щоб запланувати гру/тренування. Ви перейдете у чат-бот, де зможете вибрати дату та час.<br />Ваш візаві "<b>{0}</b>" отримає повідомлення у чат-боті для підтвердження гри.',
    vizavi_not_playable: 'Нажаль ви не можете напряму викликати цього гравця на гру, бо ви ще не є друзями і у вас немає спільної групи...',
    __trainer_booking_add_label: 'Запис на тренування',
    __trainer_booking_cancel_label: 'Скасоване тренування',
    message_group_title: 'Повідомлення в групі',
    message_group_body: 'Натиснувши кнопку <br><b>«Продовжити у чат-боті»</b>, вам відкриється канал переписки з учасниками групи у месенджері Viber.',
    start_booking_title: 'Розпочати бронювання',
    start_booking_message: 'Для того, щоб забронювати корт чи тренування, перейдіть у чат-бот.',
    continue_in_chat_bot: 'Підтвердити у чат-боті',
    continue_in_chat_bot2: 'Продовжити у чат-боті',
    new_game: 'Нова гра',
    player_profile: 'Профіль гравця',
    get_viber_contact: 'Viber контакт',
    message: 'Повідомлення',
    open_in_connect: 'Відкрити в Коннекті',
    enter_phone_number: 'Пошук за номером телефону',
    user_not_found_by_phone: '⚠️Користувача із номером телефону: <b>{0}</b> немає. Ви можете запросити його, використовуючи ваше персональне посилання на чат-бот!',
    manually_share_bot_link_title: 'Посилання на чат-бот',
    manually_share_bot_link_message: 'Це ваше персональне посилання на чат-бот. Привівши друга по цьому посиланню, вам будуть автоматично нараховуватись бонусні 3% з усіх його покупок у чат-боті!',
    group_link: 'Посилання на групу',
    share_group_link_message: 'Скопіюйте та поширте посилання на цю групу.',
    link_copied: 'Лінк скопійовано в буффер.',
    code_number_prompt: 'Введіть СМС код',
    code_number_required: 'Введіть СМС код',
    code_number_too_short: 'Код закороткий',
    phone_number_prompt: 'Введіть номер телефону',
    phone_number_required: 'Введіть номер телефону вище',
    phone_number_too_short: 'Номер телефону закороткий',
    phone_number_too_long: 'Номер телефону задовгий',
    phone_prefix_incorrect: 'Номер телефону повинен починатись префіксом: ',
    club_registration: 'Реєстрація в Сквош Центрі',
    club_registration_sms_form_top: 'Вхід',
    club_registration_sms_form_bottom: 'в Сквош Центр',
    get_sms_code: 'Отримати СМС код',
    validate_sms_code: 'Перевірити СМС код',
    ack_privacy_required: 'Будь ласка підтвердіть вашу згоду на обробку персональний данних',
    booking_tcs: 'Натискаючи "Сплатити", ви погоджуєтесь з <a target="_blank" href="{0}">договором публічної оферти</a> і даєте згоду на обробку <a target="_blank" href="{1}">персональний данних</a>.',
    __booking_tcs: 'Натискаючи "Сплатити", ви погоджуєтесь з <a target="_blank" href="https://squashcenter.com.ua/dohovir-publichnoi-oferty/">договором публічної оферти SquashFit</a> і даєте згоду на обробку <a target="_blank" href="https://squashcenter.com.ua/zhoda-na-obrobku-personalnyi-dannykh/">персональний данних</a>. SquashFit не передає дані третій стороні.',
    ack_privacy: 'Згода на обробку <a target="_blank" href="{0}">персональний данних</a>.',
    __ack_privacy: 'Згода на обробку <a target="_blank" href="https://squashcenter.com.ua/zhoda-na-obrobku-personalnyi-dannykh/">персональний данних</a>.',
    ack_tcs: 'Згода з <a target="_blank" href="{0}">договором публічної оферти</a>.',
    __ack_tcs: 'Згода з <a target="_blank" href="https://squashcenter.com.ua/dohovir-publichnoi-oferty/">договором публічної оферти</a>.',
    __ack_tcs_required: 'Будь ласка підтвердіть вашу згоду з наданням спортивно-оздоровчих послуг SquashFit',
    good_photo_required: '⚠️ Будь ласка завантажте ваше фото у хорошій якості, щоб адміністратор клубу міг ідентифікувати вас при наступному візиті.',
    picture_missing: 'Будь ласка завантажте ваше фото',
    __training: '',
    __canceled_training: '',

    full_name: 'Прізвище/Ім\'я/По-батькові',
    full_name_required: 'Введіть ваше повне Прізвище/Ім\'я/По-батькові',
    required_field: 'Це поле обов\'язкове',
    invalid_field: 'Поле заповнено невірно',
    phone_field: 'Телефон',
    birthday_field: 'Дата народження',
    fullname_field: 'Повне ім\'я',

    new_group_creation: 'Створення нової групи',
    edit_group_settings: 'Налаштування групи',
    group_name: 'Назва групи',
    enable_moderation: 'Підтверджувати нових учасників',
    class_add_label: 'Створено нову групу:',
    class_join_label: 'Приєднання до групи:',
    help_request_label: 'Запит на допомогу:',
    help_response_label: 'Пропозиція допомоги:',
    tcs_confirmation_label: 'Оновлено реєстраційні дані і ознайомлено з правилами клубу.',

    add_to_friends: 'Додати до друзів',
    add_to_group: 'Додати до групи',
    my_friends: 'Мої друзі',
    user_friends: 'Друзі користувача',
    my_groups: 'Мої групи',
    user_groups: 'Групи користувача',
    my_trainers: 'Мої тренери',
    add_new_friend: 'Додати друга',
    add_new_group: 'Створити власну групу',
    view_player: 'Перегляд гравця',

    approve_as_friends_popup_title: 'Підтвердити запит',
    approve_as_friends_popup_description: 'Натисніть "Підтвердити", щоб додати до друзів граця: ',
approve_as_friends_popup_confirmation: 'Додано до друзів!',
    send_friendship_request_popup_title: 'Надіслати запит',
    send_friendship_request_popup_description: 'Ви можете надіслати запит цьому гравцю, щоб додати його до друзів.',
send_friendship_request_popup_confirmation: 'Запит надіслано!',
    group_join_confirmation: 'Ви доєднались до групи!',
    remove_from_friends_popup_title: 'Видалити з друзів',
    remove_from_friends_popup_description: 'Натисніть "Підтвердити", щоб видалити з друзів граця: ',
remove_from_friends_popup_confirmation: 'Видалено з друзів.',
    remove_from_friends_popup_title2: 'Статус гравця',
    remove_from_friends_popup_description2: 'Цей гравець є у списку ваших друзів.',
    wait_friend_approval_popup_title: 'Очікування',
    wait_friend_approval_popup_description: 'Цей гравець ще не додав вас до своїх друзів. Очікуйте підтвердження.',
    approve_in_class_popup_title: 'Підтвердити учасника',
    approve_in_class_popup_description: 'Натисніть "Підтвердити", щоб додати цього гравця до групи: ',
    remove_from_class_popup_title: 'Видалити учасника',
    remove_from_class_popup_description: 'Натисніть "Підтвердити", щоб видалити цього гравця із групи: ',
    add_new_referral: 'Додати новий реферал',
    your_referral_title: 'Ваш реферал',
    your_referral_description: 'Ви запросили цього гравця по персональному реферальному посиланню.',
    mutual_class_popup_title: 'Спільна група',
    mutual_class_popup_description: 'Ви знаходитесь у спільній групі.',
    exit_from_group_popup_title: 'Вийти з групи',
    exit_from_group_popup_description: 'Натисніть "Підтвердити", щоб вийти з групи',
    trainer_phone: 'Телефон тренера',
    trainer_details: 'Деталі тренера',
    trainer_services: 'Послуги тренера',
    trainer_services_missing: 'Послуги тренера не сконфігуровані',
    order_training: 'Замовити тренування',
    delete_confirmation_popup_title: 'Видалити елемент?',
    delete_confirmation_popup_description: 'Натисніть "Підтвердити", щоб видалити цей елемент.',
    package_enabled: 'Послуга активована',
    package_price: 'Ціна',

    cup_profile_status: 'Ваш статус',
    cup_vizavi_status: 'Статус гравця',
    cup_player_registered: 'Гравець зареєстрований. Очукування посіву.',
    cup_player_busy: 'Виклик гравця недоступний.',
    cup_active_game: 'Активна гра',
    cup_last_game: 'Остання гра',
    cup_game_deadline: 'Внесення результату до',
    cup_game_score: 'Рахунок',
    cup_game_result_win: 'Ваш виграш',
    cup_game_result_lose: 'Ваш програш',
    cup_player_status__player_not_registered: 'Гравець не посіяний',
    cup_player_status__player_banned: 'Гравець виключений з турніру',
    cup_player_status__player_left_cup: 'Гравець залишив турнір',
    my_incomplete_status__me_not_registered: 'Ви не зареєструвались на турнір.',
    my_incomplete_status__me_quit: 'Ви залишили турнір.',
    my_incomplete_status__me_banned: 'Вас виключили з турніру :(',
    cup_player_free_but__me_not_registered: 'Гравець вільний, але ви не можете надіслати йому виклик на гру. Ви не приймаєте участі.',
    cup_player_free_but__me_quit: 'Гравець вільний, але ви не можете надіслати йому виклик на гру. Ви не приймаєте участі.',
    cup_player_free_but__me_banned: 'Гравець вільний, але ви не можете надіслати йому виклик на гру. Ви виключені з турніру.',
    cup_player_free_but__me_game_in_progress: 'Гравець вільний, але ви не можете надіслати йому виклик на гру. У вас незавершена гра.',
    cup_player_free_but__already_played: 'Гравець вільний, але ви не можете надіслати йому виклик на гру. Між вами вже зіграна остання гра.',
    cup_player_free_but__player_not_in_range: 'Гравець вільний, але його позиція не дозволяє вам надіслати йому виклик на гру.',
    cup_profile_mutual_game__mutual_game_in_progress: 'У вас активна гра!',
    cup_profile_mutual_game__mutual_game_in_confirmation_vizavi_proposal: 'Вам надіслано результат гри для підтвердження!',
    cup_profile_mutual_game__mutual_game_in_confirmation_my_proposal: 'Ви надіслали результат гри для підтвердження! Очікуйте...',
    cup_vizavi_mutual_game__mutual_game_in_progress: 'Зареєстрована спільна гра з вами!',
    cup_vizavi_mutual_game__mutual_game_in_confirmation_vizavi_proposal: 'Цей гравець надіслав вам результат гри для підтвердження!',
    cup_vizavi_mutual_game__mutual_game_in_confirmation_my_proposal: 'Цей гравець отримав вашу пропозицію підтвердити результат гри! Очікуйте...',
    cup_your_position: 'Це ваша позиція!',
    cup_you_are_free: 'Ви доступні для гри!',
    cup_player_available: 'Гравець доступний для гри!',
    cup_action_start_game: 'Давай зіграємо!',
    cup_action_enter_score: 'Зафіксувати результат!',
    cup_action_change_score: 'Змінити результат!',
    cup_action_change_score2: 'Змінити...',
    cup_action_confirm_game: 'Підтвердити результат!',
    cup_action_walkover_game: 'Walkover...',
    cup_action_send_confirmation: 'Підтвердити з суперником',
    cup_action_start_game_confirmation_title: 'Підтвердження гри',
    cup_action_start_game_confirmation_description: 'Ви дійсно бажаєте зіграти з цим гравцем?',
    cup_action_confirm_game_confirmation_title: 'Підтвердження гри',
    cup_action_confirm_game_confirmation_description: 'Ви дійсно бажаєте підтвердити результат гри?',
    cup_action_confirm_game_walkover_title: 'Підтвердження walkover',
    cup_action_confirm_game_walkover_description: 'Ви дійсно бажаєте поставити walkover в цій грі?',
    cup_player_qualification_position: '🏆 Кваліфікаційний рейтинг - <b>№{0}</b>',
    cup_game_just_confirmed: 'Гру підтверджено!',
    cup_game_just_walkovered: 'Walkover зафіксовано!',
    cup_player_status_changed: 'Ваш статус в лізі змінився!',
    cup_changes_occur: 'Відбулись зміни в лізі!',
    cup_player_position_changed: 'Ваш рейтинг в лізі змінився!',

    chief_administrator: 'Головний адміністратор',
    UAH: 'грн',
    mins: 'хв',
    morning: 'ранок',
    day_middle: 'день',
    evening: 'вечір',
    weekdays_range: 'Пн - Пт',
    weekends_range: 'Сб - Нд',
    play_conf_popup_title: 'Оновити ігровий час',
    play_conf_popup_description: '🕒 Вкажіть приблизні часові рамки, коли ви можете грати в клубі.<br>🙋‍ Це допоможе іншим гравцям надсилати вам пропозиції для гри у зручний для вас час.<br>⚙️Змінити ці налаштування ви зможете в любий момент.',
    play_able_morning: 'Можу грати вранці!',
    play_able_day_middle: 'Можу грати вдень!',
    play_able_evening: 'Можу грати ввечері!',
    play_able_weekdays: 'Пн - Пт: Чи можете грати у будні дні?',
    play_able_weekends: 'Сб - Нд: Чи можете грати на вихідних?',
    my_play_conf: 'Мій ігровий час',
    play_config_update_label: 'Оновлено ігровий час',
    more1: 'Більше',
    session_expired: 'Сecія завершилась.',
    connect_session_restart: 'Ви можете знову увійти у ваш <br><b>{0}</b> через чат-бот.',

    drag_image_here: 'Перетягніть картинку сюди',
    drag_your_avatar_here: 'Завантажте ваше фото',
    or: 'або',
    pick_image_file: 'Вибрати Картинку',
    delete_image_file: 'Видалити Картинку',

    months_short: ['Січ','Лют','Бер','Кві','Тра','Чер','Лип','Сер','Вер','Жов','Лис','Гру'],
    months_full: ['Січень','Лютий','Березень','Квітень','Травень','Червень','Липень','Серпень','Вересень','Жовтень','Листопад','Грудень'],
    days_short: ['Нед','Пон','Вів','Сер','Чет','Пят','Суб'],
    days_super_short: ['Нд','Пн','Вт','Ср','Чт','Пт','Сб'],
    days_full: ['Неділя','Понеділок','Вівторок','Середа','Четвер','П\'ятниця','Субота'],
  },
  ru: {
    powered_by_label: 'Створено командою',
    team: 'Команда',
    mobile_exit_default: '👈 Повернутись в чат-бот',
    mobile_exit_on_error: '❌ Повернутись в чат-бот',
    mobile_exit_on_success: '✅ Повернутись в чат-бот',
  },
  en: {
    powered_by_label: 'Powered by',
    team: 'Команда',
    mobile_exit_default: '👈 Повернутись в чат-бот',
    mobile_exit_on_error: '❌ Повернутись в чат-бот',
    mobile_exit_on_success: '✅ Повернутись в чат-бот',

    drag_image_here: 'Drag image here to upload',
    or: 'or',
    pick_image_file: 'Pick Image File',
    delete_image_file: 'Delete Image File',
  },
};
